import React, { useState } from 'react';
import { motion } from 'framer-motion';
type EnterButtonProps = {
  label: string;
  onEnter: () => void;
};

// Hovering fills the button from left to right; once full, the experience opens.
// A click or Enter opens it straight away (touch and keyboard).
export function EnterButton({
  label,
  onEnter
}: EnterButtonProps) {
  const [armed, setArmed] = useState(false);
  return <button type="button" onPointerEnter={e => e.pointerType === 'mouse' && setArmed(true)} onPointerLeave={() => setArmed(false)} onClick={onEnter} className="relative inline-flex h-[60px] w-[260px] items-center justify-center overflow-hidden border border-paper/50 text-[15px] font-normal tracking-[0.02em] text-paper focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-paper" data-id="element-1314" data-mp="378f7r69kgjcx">
      <span data-id="element-1315" data-mp="vl7fx9wcdu8a">{label}</span>
      <motion.span aria-hidden="true" className="absolute inset-0 flex items-center justify-center bg-paper text-ink" initial={false} animate={{
      clipPath: armed ? 'inset(0 0% 0 0)' : 'inset(0 100% 0 0)'
    }} transition={armed ? {
      duration: 1.3,
      ease: [0.65, 0, 0.35, 1]
    } : {
      duration: 0.35,
      ease: [0.22, 1, 0.36, 1]
    }} onAnimationComplete={() => {
      if (armed) onEnter();
    }} data-id="element-1316" data-mp="qkt4rizg2461">
        {label}
      </motion.span>
    </button>;
}